export default "__VITE_ASSET__Dcx4lUjI__"